import { gql } from 'apollo-angular';

export const MarkNotificationAsReceivedDocument = gql`
  mutation markNotificationAsReceived($id: Int!) {
    markNotificationAsReceived(id: $id) {
      id
    }
  }
`;
